import { Alert, CircularProgress, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import checkAvailability from "../../../api/auth/reservations/checkAvailability";
import ReservationDateRange from "../../text/ReservationDateRange";

export default function ReservationAvailability({ reservation }) {
  const [ availabilityLoading, setAvailabilityLoading ] = useState(true);
  const [ availability, setAvailability ] = useState();

  useEffect(() => {
    setAvailabilityLoading(true);
    checkAvailability(reservation.id, (response) => {
      setAvailability(response);
      setAvailabilityLoading(false);
    });
  }, [reservation]);

  console.log(availability);

  if(reservation.reservation_items.length === 0) return;

  if(!reservation.start_at) return;

  if(availabilityLoading) return <CircularProgress />;

  if(!availability) return null;

  if(availability.out_of_stock?.length === 0 && availability.low_stock?.length === 0 && availability.buffer_overlap?.length === 0) {
    return <Alert severity="success">All items are available</Alert>;
  }

  return (
    <Stack>
      {availability.out_of_stock?.map((item) => (
        <Stack key={item.id} mb={1}>
          <Alert severity="error">
            There are only {item.available} {item.name}s available for this date
          </Alert>
        </Stack>
      ))}
      {availability.low_stock?.map((item) => (
        <Stack key={item.id} mb={1}>
          <Alert severity="warning">
            {item.name} is low in stock
          </Alert>
        </Stack>
      ))}
      {availability.buffer_overlap?.map((reservation) => (
        <Stack key={reservation.id} mb={1}>
          <Alert severity="warning">
            Reservation buffer warning: {reservation.id} <ReservationDateRange reservation={reservation} />
          </Alert>
        </Stack>
      ))}
    </Stack>
  );
}